import type { Middleware } from "redux";

import { ACTION_CHANGE_ENGAGEMENT_PHASE, ACTION_START_SESSION } from "../actions/actionTypes";

const postWindowMessage = (type: string, data?: unknown) => {
    const message = {
        source: "TWILIO-WEBCHAT",
        type,
        ...(data ?? {})
    };

    window.postMessage(message, window.location.href);
};

export const windowPostMessageMiddleware: Middleware<unknown, unknown> = () => (next) => (action) => {
    switch (action.type) {
        case ACTION_CHANGE_ENGAGEMENT_PHASE:
            postWindowMessage(ACTION_CHANGE_ENGAGEMENT_PHASE, action);
            break;

        case ACTION_START_SESSION:
            postWindowMessage(ACTION_START_SESSION, {
                payload: {
                    currentPhase: action.payload.currentPhase
                }
            });
            break;

        default:
            break;
    }

    return next(action);
};
